<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.browse {
  background-color: #0d86ff;
  color: white;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.multiselect__input {
  color: #0d86ff !important;
}
input.multiselect__input {
  content: "Pilih Nama Level";
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Tambah Sertifikasi
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <form @submit.prevent="postData" id="form-data">
      <div class="card-body">
        <!-- Form Tambah Sertifikasi -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-dark h4">Sertifikasi </div>

          <div class="card-body formidentify">
            <!-- <form> -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="nama" class="font-weight-bold">Nama Sertifikasi</label>
                <TextField
                  myclass="form-control"
                  id="nama"
                  characterAllow="qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM,. 1234567890-"
                  v-model="formData.namaSertifikasi"
                  :class="{
                    'is-invalid': $v.formData.namaSertifikasi.$error,                     
                  }"
                  placeholder="Masukkan Nama Sertifikasi"
                />
                <span class="text-danger" v-if="formData.namaSertifikasi.length > 100">
                  *Nama Sertifikasi tidak dapat melebihi 100 karakter
                </span>
              </div>
            
              
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="biayaPendaftaran" class="font-weight-bold">Biaya Pendaftaran</label>
                <vue-autonumeric              
                  class="form-control"
                  :options="{
                    minimumValue: '0'
                  }"
                  v-model="formData.hargaPendaftaran"
                ></vue-autonumeric>
              </div>
              <div class="form-group col-md-6" id="divlevel">
                <label for="level" class="font-weight-bold">Level</label>
                <multiselect
                  label="namaLevel"
                  class="invalid-multiselect"
                  placeholder="Pilih Level"
                  :show-labels="false"
                  @input="(value) => updateSelect(value)"
                  v-model="multi_kategori"                  
                  id="selectLevel"
                  :options="levelPeruntukan"
                  :loading="loadingMultiSelect.isLoadingLevel"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="model_error.invalid_level">
                  Level Harus Dipilih.
                </div>
              </div>
              <!-- <div class="form-group col-md-6">
                <label for="biaya" class="font-weight-bold">Biaya Per Mata Uji</label>
                <vue-autonumeric
                  class="form-control"
                  :options="{
                    minimumValue: '0'
                  }"
                  v-model="formData.biayaPerMataUji"
                ></vue-autonumeric>
              </div> -->
              <div class="form-group col-12" id="deskripsi">
                <label for="deskripsi" class="font-weight-bold">Deskripsi</label>
                <textarea 
                  name="" 
                  id="" 
                  
                  class="form-control"
                  v-model="formData.deskripsi"
                  cols="30" 
                  rows="10">
                </textarea>
                <div 
                  class="text-danger" 
                  v-if="$v.formData.deskripsi.$error">
                  Deskripsi Harus Diisi
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Form Tambah Sertifikasi -->
      <div class="card-body" id="divmatauji" ref="divmataujiref">
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-dark h4">Daftar Mata Ujian</div>
          <div class="card-body">
            
            <div v-for="(input,k) in formData.masterMataUjiRequest" :key="k">
              <div class="form-row">
                <div class="form-group col-md-6 is-invalid">
                  <label for="mata_uji" class="font-weight-bold">Mata Ujian</label>
                  <multiselect
                    label="namaMataUji"
                    placeholder="Pilih Mata Uji"
                    :loading="loadingMultiSelect.isLoadingMataUji"
                    v-model="input.modelMultiSelect.$model"
                    :id="'idmatauji'+k"
                    :class="{'invalid-multiselect' : $v.formData.masterMataUjiRequest.$each[k].idMasterMataUji.$error}"
                    @input="(value) => pilihMataUji(value,k)"
                    @remove="(value) => onRemoveMataUji(value, k)"
                    :options="mataUji"
                    ></multiselect>
                    <div 
                      class="text-danger" 
                      v-if="$v.formData.masterMataUjiRequest.$each[k].idMasterMataUji.$error">
                      Mata Uji Harus Dipilih.
                    </div>
                </div>
                <div class="form-group col-md-5">
                  <label for="biaya" class="font-weight-bold">Biaya Per Mata Uji</label>
                  <vue-autonumeric
                    class="form-control"
                    :options="{
                      minimumValue: '0'
                    }"
                    v-model="input.biayaMataUji"
                  ></vue-autonumeric>
                </div>
                <div class="col-1 d-flex align-items-center mt-2">
                  <div
                    class="btn btn-sm btn-success ml-2"
                    @click="add(k)"
                    v-show="k == formData.masterMataUjiRequest.length-1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2"
                    @click="remove(k)"
                    v-show="k || ( !k && formData.masterMataUjiRequest.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body" id="divdokumen">
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-dark h4">Dokumen Persyaratan</div>
          <div class="card-body">
            <div
              class="form-row"
              v-for="(input, k) in formData.dokumenPendukungSertifikasis"
              :key="k"
            >
              <div class="form-group col-md-6">
                <label for="nama_dok" class="font-weight-bold">Nama Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  @input="(value) => pilihDokumen(value, k)"
                  @remove="(value) => onRemoveDokumenPendukung(value, k)"
                  :loading="loadingMultiSelect.isLoadingDokumen"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="$v.formData.dokumenPendukungSertifikasis.$each[k].idMasterDokumenPendukung.$error">
                  Dokumen Pendukung Harus Dipilih.
                </div>
              </div>
              <div class="form-group col-md-5">
                <label for="nama_dok" class="font-weight-bold">Status Dokumen</label>
                
                <select 
                  class="form-control"
                  v-model="input.statusRequired"
                  required
                  style="height: 42px"

                >
                  <option value="1">Wajib</option>
                  <option value="0">Tidak Wajib</option>
                </select>
              </div>

              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok(k)"
                  v-show="k == formData.dokumenPendukungSertifikasis.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="remove_dok(k)"
                  v-show="k || ( !k && formData.dokumenPendukungSertifikasis.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body" id="divpenerbitan">
        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-dark h4">Dokumen Persyaratan Penerbitan Sertifikat</div>
          <div class="card-body">
            <!-- <form> -->
            <div
              class="form-row"
              v-for="(input,k) in formData.dokumenPersyaratanSertifikat"
              :key="k"
            >
              <div class="form-group col-md-6">
                <label for="nama_dok" class="font-weight-bold">Nama Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  :loading="loadingMultiSelect.isLoadingDokumen"
                  @input="(value) => pilihDokumenPenerbitan(value,k)"
                  @remove="(value) => onRemoveDokumenPersyaratan(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div 
                  class="text-danger" 
                  
                  v-if="$v.formData.dokumenPersyaratanSertifikat.$each[k].idMasterDokumen.$error">
                  Dokumen Pendukung Harus Dipilih.
                </div>
              </div>
              <div class="form-group col-md-5">
                <label for="nama_dok" class="font-weight-bold">Status Dokumen</label>
                
                <select 
                  class="form-control"
                  v-model="input.statusRequired"
                  style="height: 42px"

                  required
                >
                  <option value="1">Wajib</option>
                  <option value="0">Tidak Wajib</option>
                </select>
              </div>
              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok_sertifikat(k)"
                  v-show="k == formData.dokumenPersyaratanSertifikat.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="remove_dok_sertifikat(k)"
                  v-show="k || ( !k && formData.dokumenPersyaratanSertifikat.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <div class="row">
          <CCol sm="12">
            <label for class="font-weight-bold">Status Sertifikasi</label>
            <br />
            <div class="d-flex align-items-center">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  class="custom-control-input"
                  value="1"
                  v-model="formData.status"
                  name="customRadio"
                  id="aktif"
                  checked="true"
                />
                <label class="custom-control-label" for="aktif">Aktif</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  class="custom-control-input"
                  value="0"
                  v-model="formData.status"
                  name="customRadio"
                  id="tidak_aktif"
                />
                <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
              </div>
            </div>
            <div 
              class="text-danger" 
              v-if="$v.formData.status.$error">
              *Mohon pilih status
            </div>
          </CCol>
        </div>
        <!-- End Form Dokumen Upload -->
      </div>

      <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
        <Button
          style="float:right"
          class="btn btn-md btn-success px-4 py-2"
          type="submit"
          color="success"
        >Simpan</Button>
        <br />
        <br />
      </div>
    </form>
  </div>
</template>
<script>
import { required, maxLength } from 'vuelidate/lib/validators';

import LevelService from "../../../services/datamaster/level.service";
import SertifikasiService from "../../../services/sertifikasi/master-sertifikasi.service";
import MasterMataUjiService from "../../../services/sertifikasi/mata-uji.service";
import AutoNumeric from "../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";
import { MasterDokumen } from "../../../mixins/master/MasterDokumen";
import { AlertUtils } from "../../../mixins/AlertUtils";

import TextField from "../../../components/formcomponent/TextField"
import UserGraderService from "../../../services/sertifikasi/user-grader.service"

export default {
  name: 'master-sertifikasi-tambah',
  mixins: [MasterDokumen,AlertUtils],
  data() {
    return {
      model_error : {
        invalid_level : false,
      },
      
      multi_kategori: [],
      mataUji: [],
      levelPeruntukan: [],
      Level: [],
      option_grader : [],
      actionPost: "",
      formData: {
        deskripsi : '',
        masterMataUjiRequest: [
          {
            id : 0,
            idMasterMataUji: "",
            namaMataUji: "",
            deskripsi: "",
            batasNilai: "",
            graderSatu: "",
            graderDua : "",
            invalid_mata_uji : false,
            biayaMataUji : 0,
            modelMultiSelect : []
          },
        ],
        dokumenPendukungSertifikasis: [
          {
            idMasterDokumenPendukung: "",
            invalid_dokumen : false,
            statusRequired : '1',
            modelMultiSelect: [],
          },
        ],

        dokumenPersyaratanSertifikat: [
          {
            idDokumenPendukung : "",
            idMasterDokumen: "",
            invalid_dokumen : false,
            statusRequired : '1',
            modelMultiSelect: [],
          },
        ],

        biayaPerMataUji: "0",
        idLevelAnggota: "",
        namaLevel: "",
        kodeSertifikasi: "",
        levelPeruntukan: "",
        namaSertifikasi: "",
        hargaPendaftaran: "0",
        status: "",
      },
    };
  },

  validations: {
    formData: {
      namaSertifikasi: { 
        required,
        maxLength: maxLength(100)
      },
      levelPeruntukan: { required },
      deskripsi: { required },
      biayaPerMataUji: { required },
      hargaPendaftaran: { required },
      masterMataUjiRequest: {
        required,
        $each: {
          idMasterMataUji: {
            required            
          }
        }
      },
      dokumenPendukungSertifikasis: {
        required,
        $each: {
          idMasterDokumenPendukung: {
            required
          }
        }
      },
      dokumenPersyaratanSertifikat: {
        required,
        $each: {
          idMasterDokumen: {
            required
          }
        }
      },
      status: {
        required
      }     
    }
  },
 
  components: {
    VueAutonumeric,
    TextField
  },

  mounted() {
    this.formData.namaSertifikasi
    this.getLevel();
    this.getDataPetugasGrader();
    this.getMataUji();
    this.getAllDokumen();
  },
  
  methods: {

    pilihGraderDua(value, k) {
      this.formData.masterMataUjiRequest[k].graderDua = value.id
    },

    pilihGraderSatu(value, k) {
      this.formData.masterMataUjiRequest[k].graderSatu = value.id
    },

    getDataPetugasGrader(){
      UserGraderService.getUserGrader(0,1000000000,'default')
      .then(response => {
        // comment console console.log("INI DATA PETUGAS GRADER")
        // comment console console.log(response)
        this.option_grader = response.data.data.content
      }).catch(error => {
        // comment console console.log(error);
      })
    },

    pilihDokumenPenerbitan(value, k) {
      if(value.idMasterDokumen != null) {
        this.formData.dokumenPersyaratanSertifikat[k].invalid_dokumen = false
      }

      var data = value.idMasterDokumen;
      var status = 0
    
      for (
        let index = 0;
        index < this.formData.dokumenPersyaratanSertifikat.length;
        index++
      ) {

        var idMasterDokumen = this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen;
        var idSelectMasterDokumen = data

        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");          
          status = 1
          this.formData.dokumenPersyaratanSertifikat[k].modelMultiSelect = []
          return false;
        }
      }  
      
      if(status == 0) {
        this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen = value.idMasterDokumen;
      }
    },

    pilihDokumen(value, k) {
      if(value.idMasterDokumen != null) {
        this.formData.dokumenPendukungSertifikasis[k].invalid_dokumen = false
      }

      var data = value.idMasterDokumen;
      var status = 0;
      for (
        let index = 0;
        index < this.formData.dokumenPendukungSertifikasis.length;
        index++
      ) {
        var idMasterDokumen = this.formData.dokumenPendukungSertifikasis[index].idMasterDokumenPendukung;

        var idSelectMasterDokumen = data

        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");          
          status = 1
          this.formData.dokumenPendukungSertifikasis[k].modelMultiSelect = []  
          return false;
        }
      }  
      
      if(status == 0) {
        this.formData.dokumenPendukungSertifikasis[k].idMasterDokumenPendukung = value.idMasterDokumen;
      }
    },

    uploadDok(e, index) {
      // comment console console.log(index);
      var typeDok = e.target.files[0].type;
      var typeDokumen = typeDok.split("/");

      if (typeDokumen[1] != "pdf") {
        this.alertError("Dokumen Harus Bertipe PDF");
        return false;
      } else {
        this.formData.dokumenPendukungSertifikasis[index].contohDokumen = e.target.files[0];
        this.formData.dokumenPendukungSertifikasis[index].fileName = e.target.files[0].name;
        this.formData.dokumenPendukungSertifikasis[index].statusUpdateFile = e.target.files[0].name;
      }
    },

    pilihMataUji(event, k) {
      if(event.idMasterMataUji != null) {
        this.formData.masterMataUjiRequest[k].invalid_mata_uji = false
      }

      var data = event.idMasterMataUji
      var status = 0
      for (
        let index = 0;
        index < this.formData.masterMataUjiRequest.length;
        index++
      ) {
        var idMasterMataUji = this.formData.masterMataUjiRequest[index].idMasterMataUji;
        var idSelectMataUji = data;

        if (idMasterMataUji == idSelectMataUji) {
          this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
          status = 1
          this.formData.masterMataUjiRequest[k].modelMultiSelect = []       
          return false;
        } 
      }
      if(status == 0) {
        this.formData.masterMataUjiRequest[k].idMasterMataUji = data;
      } 
    },

    onRemoveMataUji(value, index) {
      const status = 0;

      if(status == 1) {
        this.formData.masterMataUjiRequest[index] = value;
      } else {
        this.formData.masterMataUjiRequest[index].idMasterMataUji = ""
        status = 1;
      }
    },

    onRemoveDokumenPendukung(value, index) {      
      const status = 0;

      if(status == 1) {
        this.formData.dokumenPendukungSertifikasis[index] = value;
      } else {        
        this.formData.dokumenPendukungSertifikasis[index].idMasterDokumenPendukung = ""
        status = 1;
      }
    },

    onRemoveDokumenPersyaratan(value, index) {
      const status = 0;

      if(status == 1) {
        this.formData.dokumenPersyaratanSertifikat[index] = value;
      } else {
        this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen = "";
        status = 1;
      }
    },
   
    add(index) {
      this.formData.masterMataUjiRequest.push({
        id : index,
        mata_uji: "",
        idMasterMataUji : "",
        keterangan: "",
        nilai: "",
        graderSatu: "",
        graderDua : "",
        invalid_mata_uji : false,
        biayaMataUji : 0,
        modelMultiSelect : []
      });

      return false;
    },

    add_dok(index) {
      this.formData.dokumenPendukungSertifikasis.push({
        kodeDokumen: "",
        namaDokumen: "",
        contohDokumen: "",
        statusRequired : '',
        idMasterDokumenPendukung : "",
        invalid_dokumen : false,
        fileName: "",
      });
    },

    remove_dok(index) {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus dokumen ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {    
            this.formData.dokumenPendukungSertifikasis.splice(index, 1);
            this.alertSuccess("Dokumen Pedukung Berhasil Dihapus")
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });          
    },
    
    add_dok_sertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.push({
        idDokumenPendukung : "",
        idMasterDokumen : "",
        idMasterDokumenPendukung : "",
        invalid_dokumen : false,
        statusRequired : '',
      });
    },

    remove(index) {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus mata uji ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {    
            this.formData.masterMataUjiRequest.splice(index, 1);
            this.alertSuccess("Mata Uji Berhasil Dihapus")
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });               
    },

    remove_dok_sertifikat(index) {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus dokumen ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {    
            this.formData.dokumenPersyaratanSertifikat.splice(index, 1);
            this.alertSuccess("Dokumen Persyaratan Berhasil Dihapus")
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });         
    },

    getMataUji() {
      var vm = this;
      MasterMataUjiService.getAllMataUji()
      .then((response) => {
        vm.mataUji = response.data.data.content;
      })
      .catch((error) => {
        // comment console console.log(error);
      });
    },

    getLevel() {
      var vm = this;
      LevelService.getAllLevel()
        .then((response) => {
          vm.levelPeruntukan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      
      if(event == undefined || event == null || event.idLevelAnggota == undefined || event.idLevelAnggota == null) {
        this.formData.levelPeruntukan = ""
        // comment console console.log("LEVEL KOSONG")
      }
      if(event.idLevelAnggota != null ) {
        this.model_error.invalid_level = false;
        this.formData.levelPeruntukan = event.idLevelAnggota;
      } 
    },

    postData() {
  
      this.$v.$touch();
      if(this.$v.formData.masterMataUjiRequest.$error) {
        var container = this.$el.querySelector("#divmatauji");
        container.scrollIntoView()
        return false
      }
       
      if(this.$v.formData.dokumenPendukungSertifikasis.$error) {
        var container = this.$el.querySelector("#divdokumen");
        container.scrollIntoView()
        return false
      }
     
     
      if(this.$v.formData.dokumenPersyaratanSertifikat.$error) {
        var container = this.$el.querySelector("#divpenerbitan");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formData.namaSertifikasi.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formData.levelPeruntukan.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formData.biayaPerMataUji.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formData.hargaPendaftaran.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formData.status.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }

      if(this.$v.$invalid) {
        return;
      } else {
        this.insertData(this.formData)
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      
      for (
        let index = 0;
        index < formData.masterMataUjiRequest.length;
        index++
      ) {
        for (
          let indexTwo = index + 1;
          indexTwo < formData.masterMataUjiRequest.length;
          indexTwo++
        ) {
          if (
            formData.masterMataUjiRequest[index].idMasterMataUji ==
            formData.masterMataUjiRequest[indexTwo].idMasterMataUji
          ) {
            this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
            return false;
          }
        }
      }

      for (
        let contohDokumen = 0;
        contohDokumen < formData.dokumenPendukungSertifikasis.length;
        contohDokumen++
      ) {
        for (
          let contohDokumenTwo = contohDokumen + 1;
          contohDokumenTwo < formData.dokumenPendukungSertifikasis.length;
          contohDokumenTwo++
        ) {
          if (
            formData.dokumenPendukungSertifikasis[contohDokumen].idMasterDokumenPendukung ==
            formData.dokumenPendukungSertifikasis[contohDokumenTwo].idMasterDokumenPendukung
          ) {
            this.$swal.fire({
              title: "Peringatan!",
              text: "Dokumen Tidak Boleh Sama",
              icon: "error",
              showCancelButton: true,
            });

            return false;
          }
        }
      }

      var vm = this;
      SertifikasiService.postSertifikasi(formData)
      .then((response) => {
        loader.hide();
        vm.myModal = false;
        vm.alertSuccess();

        vm.$router.push({ path: "/sertifikasi/master-sertifikasi" });
      })
      .catch((error) => {
        loader.hide();
        // comment console console.log(error);
        vm.alertError(error.response.data.message);
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
